<script setup lang="ts">
const { signIn } = useAuth();
// Zitadel handles forgot-password via its hosted UI.
onMounted(() => signIn('zitadel'));
</script>
<template>
  <div class="flex flex-col items-center justify-center h-screen">
    <p class="text-gray-500">Redirecting to sign in to reset your password…</p>
  </div>
</template>
